import { BrowserRouter as RouterB, HashRouter as Router, Route, Routes } from "react-router-dom";
import HomeLayout from "./pages/Home";
import Login from "./pages/Login";
import Cadastro from "./pages/Cadastro";
import FinalizarCadastro from "./pages/FinalizarCadastro";
import UsuarioCadastrado from "./components/UsuarioCadastrado";
import AbasWip from "./pages/AbasWIP";
import RevisarCadastro from "./pages/RevisarCadastro";
import {TestField} from "./pages/testField/TestField";
import { Acordeao } from "./test/Accordion";
import RedefinirSenha from "./pages/RedefinirSenha";
import { EquipamentosProvider } from "./contexts/EquipamentoContext";

function App() {
  return (
    <EquipamentosProvider>
      <Router >
        <Routes >
          <Route element={<HomeLayout />}>
            <Route path="/" element={<UsuarioCadastrado />} />
            <Route path="/aguardarCadastro" element={<UsuarioCadastrado />} />
            <Route path="/abasWIP" element={<AbasWip />} />
          </Route>
          <Route path="/testField" element={<TestField />} />
          <Route path="/login" element={<Login />} />
          <Route path="/cadastro" element={<Cadastro />} />
          <Route path="/concluirCadastro" element={<FinalizarCadastro />} />
          <Route path="/revisarCadastro" element={<RevisarCadastro />} />
          <Route path="/accordion" element={<Acordeao />} />
          <Route path="/RedefinirSenha" element={<RedefinirSenha />} />
          <Route path="*" element={<div>Página não encontrada (404)</div>} />
        </Routes>
      </Router>
    </EquipamentosProvider>
  );
}

export default App;
